var map = {
	"./redcrm/routes/index.js": "f56d",
	"./redcrm/routes/redcrm-page.js": "def1",
	"./redsurvey/routes/index.js": "ae50",
	"./redsurvey/routes/redsurvey-page.js": "28ba",
	"./redworks/routes/index.js": "e7ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ffd";